import { initClient } from "rwsdk/client"

// Initialize the main client
initClient()
